import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/app-core/services/user.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-definir-senha',
    templateUrl: './definir-senha.component.html',
    providers: [UserService],
})
export class DefinirSenhaComponent implements OnInit {
    public token: string = '';
    public novaSenha: string = '';
    public confirmarSenha: string = '';
    public loading: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.token = this.route.snapshot.paramMap.get('token') || '';
    }

    public salvar() {
        if (!this.novaSenha || this.novaSenha.length < 6) {
            Swal.fire('Atenção', 'A senha deve ter no mínimo 6 caracteres.', 'warning');
            return;
        }

        if (this.novaSenha !== this.confirmarSenha) {
            Swal.fire('Atenção', 'As senhas não coincidem.', 'warning');
            return;
        }

        this.loading = true;

        this.userService.definirSenha(this.token, this.novaSenha).subscribe({
            next: () => {
                this.loading = false;
                Swal.fire('Sucesso!', 'Senha definida com sucesso. Você já pode fazer login.', 'success').then(() => {
                    this.router.navigate(['/principal']);
                });
            },
            error: (err: any) => {
                this.loading = false;
                const msg = err?.error?.message || 'Token inválido ou expirado.';
                Swal.fire('Erro', msg, 'error');
            },
        });
    }
}
